import moment from "moment";

export const dateEqualFilterFn = (rows, id, filterValues) => {
  // Note: FilterValues format is "YYYY-MM-DD"

  return rows.filter((row) => {
    const rowValue = row.values[id];

    if (!rowValue || rowValue === "") return false; // Skip if row value is empty or null

    return moment(rowValue, "YYYY-MM-DD").isSame(filterValues);
  });
};

function DateColumnFilter({ column }) {
  const { filterValue = "", setFilter, id } = column;

  const onChange = (event) => {
    setFilter(event.target.value || undefined);
  };

  return (
    <input
      id={id}
      className="form-control form-control-sm"
      type="date"
      value={filterValue}
      onChange={onChange}
    />
  );
}

export default DateColumnFilter;
